// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});


// Design


export function sportbuttonoff_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here:
	// Show
	$w('#sportbuttonon').show()
	$w('#comfortluxurybuttonoff').show()
	$w('#premiumbuttonoff').show()
	$w('#sportoverview').show()
	$w('#sportfront').show()
	$w('#sportrear').show()

	// Hide
	$w('#sportbuttonoff').hide()
	$w('#comfortluxurybuttonon').hide()
	$w('#premiumbuttonon').hide()
	$w('#premiumoverview').hide()
	$w('#premiumfront').hide()
	$w('#premiumrear').hide()
	$w('#comfortoverview').hide()
	$w('#comfortfront').hide()
	$w('#comfortrear').hide() 
}

export function premiumbuttonoff_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here:
	// Show
	$w('#premiumbuttonon').show()
	$w('#comfortluxurybuttonoff').show()
	$w('#sportbuttonoff').show()
	$w('#premiumoverview').show()
	$w('#premiumfront').show()
	$w('#premiumrear').show()

	// Hide
	$w('#sportbuttonon').hide()
	$w('#comfortluxurybuttonon').hide()
	$w('#premiumbuttonoff').hide()
	$w('#sportoverview').hide()
	$w('#sportfront').hide()
	$w('#sportrear').hide()
	$w('#comfortoverview').hide()
	$w('#comfortfront').hide()
	$w('#comfortrear').hide() 
}

export function comfortluxurybuttonoff_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here:
	// Show
	$w('#comfortluxurybuttonon').show()
	$w('#sportbuttonoff').show()
	$w('#premiumbuttonoff').show()
	$w('#comfortoverview').show()
	$w('#comfortfront').show()
	$w('#comfortrear').show()

	// Hide
	$w('#comfortluxurybuttonoff').hide()
	$w('#sportbuttonon').hide()
	$w('#premiumbuttonon').hide()
	$w('#premiumoverview').hide()
	$w('#premiumfront').hide()
	$w('#premiumrear').hide()
	$w('#sportoverview').hide()
	$w('#sportfront').hide()
	$w('#sportrear').hide() 
}


// Safety




export function preventivebuttonoff_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here:
	// Show
	$w('#preventivebuttonon').show()
	$w('#passivebuttonoff').show()
	$w('#activebuttonoff').show()
	$w('#preventivegroup').show()

	// Hide
	$w('#preventivebuttonoff').hide()
	$w('#passivebuttonon').hide()
	$w('#activebuttonon').hide()
	$w('#passivegroup').hide()
	$w('#activegroup').hide()
}

export function activebuttonoff_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here:
	// Show
	$w('#activebuttonon').show()
	$w('#passivebuttonoff').show()
	$w('#preventivebuttonoff').show()
	$w('#activegroup').show()

	// Hide
	$w('#activebuttonoff').hide()
	$w('#passivebuttonon').hide()
	$w('#preventivebuttonon').hide()
	$w('#passivegroup').hide()
	$w('#preventivegroup').hide() 
}

export function passivebuttonoff_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here:
	// Show
	$w('#passivebuttonon').show()
	$w('#preventivebuttonoff').show()
	$w('#activebuttonoff').show()
	$w('#passivegroup').show()

	// Hide
	$w('#passivebuttonoff').hide()
	$w('#preventivebuttonon').hide()
	$w('#activebuttonon').hide()
	$w('#preventivegroup').hide()
	$w('#activegroup').hide() 
}